export default __webpack_public_path__ + "static/media/team5.e404cc3e.jpg";